import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/overview/reports";

export const Route = createFileRoute("/admin/_overview/reports")({
  component: Page,
});
